import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import {getTrainingWithProgress} from 'api/services/lesson-service';
import {IGetTrainingWithProgressRequest} from "api/models/request/IGetTrainingWithProgressRequest";
import {IGetTrainingWithProgressResponse} from "api/models/response/IGetTrainingWithProgressResponse";

export const useGetTrainingWithProgress = () => {
  const { callAPI, loading } = useWorkspaceApiCall<IGetTrainingWithProgressRequest, IGetTrainingWithProgressResponse>(
      getTrainingWithProgress,
      "",
      "getTrainingWithProgress.error"
  );

  return {
    fetchTrainingWithProgress: callAPI,
    fetchTrainingWithProgressPending: loading
  };
};